exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/* #1b9bff */\n.side-bar-container {\n  background-color: black;\n  color: white;\n  font-family: 'Oxygen Mono', Tahoma, Arial, sans-serif;\n  padding-right: 5px;\n  background-color: #1b9bff; }\n", "", {"version":3,"sources":["/usr/src/app/src/components/SideBarMenu/SideBarContainer/SideBarContainer.scss"],"names":[],"mappings":"AAAA,aAAa;AACb;EACE,wBAAwB;EACxB,aAAa;EACb,sDAAsD;EACtD,mBAAmB;EACnB,0BAA0B,EAAE","file":"SideBarContainer.scss","sourcesContent":["/* #1b9bff */\n.side-bar-container {\n  background-color: black;\n  color: white;\n  font-family: 'Oxygen Mono', Tahoma, Arial, sans-serif;\n  padding-right: 5px;\n  background-color: #1b9bff; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"sourceMap":true,"minimize":false}!../~/postcss-loader?pack=sass!../~/sass-loader!./components/SideBarMenu/SideBarContainer/SideBarContainer.scss
// module id = 1066
// module chunks = 0